export default __webpack_public_path__ + "static/media/googlecalendar.80bef315.svg";